export default __webpack_public_path__ + "static/bg-offer-compressed-d473531042ef08985055272aeb06589d.jpg";